import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * If the given string is a full HTML document (contains <html> or <!DOCTYPE>),
 * extract only the inner <body> content so it can be safely embedded inside
 * the email template. Plain HTML fragments are returned unchanged.
 */
export function extractEmailBody(html: string): string {
  if (!html) return html;
  const match = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
  if (match) return match[1].trim();
  // Fallback: strip doctype/html/head wrappers without a closing </body>
  if (/<html[\s>]/i.test(html) || /<!DOCTYPE\s+html/i.test(html)) {
    return html
      .replace(/<!DOCTYPE[^>]*>/gi, "")
      .replace(/<html[^>]*>/gi, "")
      .replace(/<\/html>/gi, "")
      .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, "")
      .replace(/<\/?body[^>]*>/gi, "")
      .trim();
  }
  return html;
}
